import { render, staticRenderFns } from "./PermissionMsg.vue?vue&type=template&id=d8b85590&scoped=true&"
import script from "./PermissionMsg.vue?vue&type=script&lang=js&"
export * from "./PermissionMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b85590",
  null
  
)

export default component.exports